export const contactOwner = {
    partnerID: 'partnerID',
    buildingID: 'buildingID',
}

export const selectContactOwnerOptions = [
    {
        value: contactOwner.buildingID,
        label: 'For building',
    },
    {
        value: contactOwner.partnerID,
        label: 'For partner',
    }
];

export const contactTypes = {
    name: 'name',
    email: 'email',
    phone: 'phone'
}

export const selectContactTypesOptions = [
    {
        value: contactTypes.name,
        label: 'Name',
    },
    {
        value: contactTypes.email,
        label: 'Email',
    },
    {
        value: contactTypes.phone,
        label: 'Phone',
    }
]